import { type Ref, computed } from 'vue'

import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { useBuybackOffer } from './useBuybackOffer'

type DiscountableElement = { price: Price; priceNew?: Price }

/**
 */
export function useDiscountedPrice<T extends DiscountableElement>(
  elements: Ref<T[] | T | null | undefined>,
) {
  const { getDiscountedPriceForProductCard } = useBuybackOffer()
  const { user } = useUserStore()

  function withDiscountedPrice(element: T) {
    const isEligible =
      user.value.cartItemsCount === 0 && Boolean(element.priceNew)

    return {
      ...element,
      discountedPrice: isEligible
        ? getDiscountedPriceForProductCard(element.price)
        : undefined,
    }
  }

  const products = computed(() =>
    Array.isArray(elements.value)
      ? elements.value.map(withDiscountedPrice)
      : [],
  )

  const product = computed(() =>
    elements.value && !Array.isArray(elements.value)
      ? withDiscountedPrice(elements.value)
      : null,
  )

  return { products, product }
}
